export default "__VITE_ASSET__3f6b1c02__"